import { DEFAULT_APARTMENT_INFO, } from "../ordering";
export const LEGACY_APARTMENT_INFO_KEY = "deliveryAddress";
export class LegacyApartmentInfoStorageManager {
    constructor(params) {
        this.country = params.country;
    }
    store(toStore) {
        throw new Error("Method not implemented.");
    }
    restore() {
        const legacyApartmentInfoDataString = localStorage.getItem(LEGACY_APARTMENT_INFO_KEY);
        if (legacyApartmentInfoDataString === null) {
            return null;
        }
        const legacyApartmentInfoData = JSON.parse(legacyApartmentInfoDataString);
        try {
            if (this.country === "RO") {
                return {
                    type: "Romanian",
                    ...DEFAULT_APARTMENT_INFO,
                    ...legacyApartmentInfoData.extra,
                };
            }
            else {
                return {
                    type: "Default",
                    ...DEFAULT_APARTMENT_INFO,
                    aptNumber: legacyApartmentInfoData.extra.aptNumber,
                    floor: legacyApartmentInfoData.extra.floor,
                };
            }
        }
        catch (_) {
            return null;
        }
    }
    erase() {
        throw new Error("Method not implemented.");
    }
}
